import type { MeProfile } from '@/api/types/entities';
import { isPlatformStaffRole } from '@/utils/teamRoles';
import { normalizeWorkspaceRole } from '@/utils/workspaceRoles';

const ADMIN_CATEGORIES = ['', 'SEARCH', 'RESULT', 'NOTIFICATION', 'TEAM', 'SUBSCRIPTION', 'SYSTEM'] as const;
const SUBSCRIBER_CATEGORIES = ['', 'SEARCH', 'RESULT', 'NOTIFICATION', 'SUBSCRIPTION'] as const;

export function canViewTeamActivity(me: MeProfile | null | undefined): boolean {
  if (!me) return false;
  if (isPlatformStaffRole(me.role)) return true;
  if (me.permissions?.canManageWorkspaceMembers) return true;
  const membershipRole = normalizeWorkspaceRole(me.membershipRole);
  return membershipRole === 'workspace_admin';
}

export function customerActivityCategoriesForUser(me: MeProfile | null | undefined): readonly string[] {
  return canViewTeamActivity(me) ? ADMIN_CATEGORIES : SUBSCRIBER_CATEGORIES;
}

export function isTeamActivityItem(item: { category?: string | null; type?: string | null }): boolean {
  const category = String(item.category || '').toUpperCase();
  const type = String(item.type || '');
  return category === 'TEAM' || type.startsWith('team.');
}
